import { values } from '@dokucoach/common-types';
import { CareLevel, CostAssignmentType, CostBearerType } from '@dokucoach/invoicing-types';
import { mixed, object, string } from 'yup';
import { EuroValue } from '../../common';

export type IInvoiceCostAssignment = {
  id: string;
  costAssignmentType: CostAssignmentType;
  careLevel: CareLevel | null;
  costBearerType: CostBearerType;
  label: string;
  amount: number;
  residentMonthlyIncomingFundId: string | null;
};

export type IInvoiceCostAssignmentCreate = {
  costAssignmentType: CostAssignmentType;
  careLevel?: CareLevel | null;
  costBearerType: CostBearerType;
  label: string;
  amount: number;
  residentMonthlyIncomingFundId?: string | null;
};

export const IInvoiceCostAssignmentCreateSchema = object({
  costAssignmentType: mixed<CostAssignmentType>().oneOf(values(CostAssignmentType)).required(),
  careLevel: mixed<CareLevel>().oneOf(values(CareLevel)).nullable().optional(),
  costBearerType: mixed<CostBearerType>().oneOf(values(CostBearerType)).required(),
  label: string().required(),
  amount: EuroValue.required(),
  residentMonthlyIncomingFundId: string().nullable().optional(),
});

export type IInvoiceCostAssignmentUpdate = {
  costAssignmentType?: CostAssignmentType;
  careLevel?: CareLevel | null;
  costBearerType?: CostBearerType;
  label?: string;
  amount?: number;
  residentMonthlyIncomingFundId?: string | null;
};

export const IInvoiceCostAssignmentUpdateSchema = object({
  costAssignmentType: mixed<CostAssignmentType>().oneOf(values(CostAssignmentType)).optional(),
  careLevel: mixed<CareLevel>().oneOf(values(CareLevel)).nullable().optional(),
  costBearerType: mixed<CostBearerType>().oneOf(values(CostBearerType)).optional(),
  label: string().optional(),
  amount: EuroValue.optional(),
  residentMonthlyIncomingFundId: string().nullable().optional(),
});
